import { UserMenus } from "./types";
import FunCentreSectionHeader from "./FunCentreSectionHeader";

const SpinAWheelNavMenuItemNew = ({ userData }: { userData: UserMenus }) => {
  if (!userData.IsAuthenticated || !userData.FunCentre) {
    return null;
  }

  return (
    <div className="w-full min-w-0">
      <div className="text-gray-1 font-jost text-xs lg:text-sm font-medium leading-4 lg:leading-5 uppercase">
        MORE FUN AWAITS
      </div>
      <div className="mt-3 lg:mt-4">
        <FunCentreSectionHeader smarticoData={userData.FunCentre} />
      </div>
    </div>
  );
};

export default SpinAWheelNavMenuItemNew;
